import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ffa10100"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  key: 0,
  class: "label-text"
};
const _hoisted_3 = {
  class: "token-text"
};
const _hoisted_4 = {
  key: 1,
  class: "sfe-arrow-right"
};
const _hoisted_5 = {
  class: "options-wrap"
};
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['select-wrap', {
      'dialog-select-wrap': $props.isDialog
    }])
  }, [_createVNode(_component_el_tooltip, {
    placement: "bottom-start",
    trigger: "click",
    disabled: $setup.filterData.length <= 1,
    teleported: false,
    "show-arrow": false,
    manual: true,
    "hide-after": 50,
    "popper-class": "select-wrap-tooltip",
    "popper-options": $setup.popperOptions,
    visible: $setup.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => $setup.visible = $event)
  }, {
    content: _withCtx(() => [_createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterData, item => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass(["flex-row flex-items-center", {
          'active': item.type === $setup.selectedValue.type
        }]),
        key: item.type,
        onClick: $event => _ctx.handleSelect(item)
      }, _toDisplayString($setup.t(item.key)), 11, _hoisted_6);
    }), 128))])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(`select-button-box ${$setup.filterData.length > 1 ? 'select-button-cursor' : ''}`),
      id: $setup.selectRef
    }, [$props.label ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.label) + ": ", 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_3, _toDisplayString($setup.t($setup.selectedValue.key)), 1), $setup.filterData.length > 1 ? (_openBlock(), _createElementBlock("i", _hoisted_4)) : _createCommentVNode("", true)], 10, _hoisted_1)]),
    _: 1
  }, 8, ["disabled", "popper-options", "visible"])], 2);
}